import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import usePromiseDialog from '@shared/hooks/src/usePromiseDialog'

import ConfirmationV2 from '@components/Dialog/ConfirmationV2'

export default function usePEPWarning() {
  return usePromiseDialog({
    component: ConfirmationV2,
    getProps: () => ({
      variant: 'warning',
      title: 'PEP Encounter Confirmation',
      rejectLabel: 'Cancel',
      confirmLabel: 'Confirm',
      description: (
        <Stack sx={{ textAlign: 'left' }}>
          <Typography>By creating this PEP encounter, you are acknowledging:</Typography>
          <Stack component="ul">
            <Typography component="li">It is between Monday - Friday 2pm ET</Typography>
            <Typography component="li">The patient will be using an Avita/contracted pharmacy</Typography>
            <Typography component="li">The patient will be transitioning to PrEP</Typography>
          </Stack>
        </Stack>
      ),
    }),
  })
}
